import { useRef, useState, useCallback } from 'react'

interface HtmlPreviewFrameProps {
  html: string
  className?: string
  maxHeight?: number
}

// Renderizza HTML arbitrario (es. corpo di un template email) isolato dal documento
// principale: un <div dangerouslySetInnerHTML> avrebbe iniettato <style>/<script> del
// contenuto direttamente nel DOM dell'app, capaci di alterare stili globali (es. regole
// dark-mode dei client email che finivano per colpire anche la sidebar). L'iframe
// sandboxato mantiene il contenuto in un documento separato.
export function HtmlPreviewFrame({ html, className = '', maxHeight = 400 }: HtmlPreviewFrameProps) {
  const [height, setHeight] = useState(maxHeight)
  const iframeRef = useRef<HTMLIFrameElement>(null)

  const handleLoad = useCallback(() => {
    const doc = iframeRef.current?.contentDocument
    if (doc) {
      setHeight(Math.min(doc.documentElement.scrollHeight || maxHeight, maxHeight))
    }
  }, [maxHeight])

  return (
    <iframe
      ref={iframeRef}
      srcDoc={html}
      onLoad={handleLoad}
      sandbox="allow-same-origin"
      title="Anteprima email"
      className={`w-full border-0 ${className}`}
      style={{ height, maxHeight }}
    />
  )
}
